import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Scanner from './pages/Scanner';
import AddressLookup from './pages/AddressLookup';
import GraphVisualization from './pages/GraphVisualization';
import PoolAnalysis from './pages/PoolAnalysis';
import Settings from './pages/Settings';
import ImportExport from './pages/ImportExport';
import ApiDocs from './pages/ApiDocs';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="scanner" element={<Scanner />} />
        <Route path="lookup" element={<AddressLookup />} />
        <Route path="graph" element={<GraphVisualization />} />
        <Route path="pools" element={<PoolAnalysis />} />
        <Route path="settings" element={<Settings />} />
        <Route path="import-export" element={<ImportExport />} />
        <Route path="api-docs" element={<ApiDocs />} />
      </Route>
    </Routes>
  );
}

export default App;
